export default IconIroningSteam => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-ironing-steam" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 19v2" />
  <path d="M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8" />
  <path d="M8 19l-1 2" />
  <path d="M16 19l1 2" />
</svg>`;